// Main entrypoint for libraries using yargs-parser in Node.js
// CJS and ESM environments:
import { format } from 'util';
import { readFileSync } from 'fs';
import { normalize, resolve } from 'path';
import { camelCase, decamelize } from './string-utils.js';
import { YargsParser } from './yargs-parser.js'; // See https://github.com/yargs/yargs-parser#supported-nodejs-versions for our
// version support policy. The YARGS_MIN_NODE_VERSION is used for testing only.

var minNodeVersion = process && process.env && process.env.YARGS_MIN_NODE_VERSION ? Number(process.env.YARGS_MIN_NODE_VERSION) : 10;

if (process && process.version) {
  var major = Number(process.version.match(/v([^.]+)/)[1]);

  if (major < minNodeVersion) {
    throw Error("yargs parser supports a minimum Node.js version of ".concat(minNodeVersion, ". Read our version support policy: https://github.com/yargs/yargs-parser#supported-nodejs-versions"));
  }
} // Creates a yargs-parser instance using Node.js standard libraries:


var _env = process ? process.env : {};

var parser = new YargsParser({
  cwd: process.cwd,
  env: function env() {
    return _env;
  },
  format: format,
  normalize: normalize,
  resolve: resolve,
  // TODO: figure  out a  way to combine ESM and CJS coverage, such  that
  // we can exercise all the lines below:
  require: function (_require) {
    function require(_x) {
      return _require.apply(this, arguments);
    }

    require.toString = function () {
      return _require.toString();
    };

    return require;
  }(function (path) {
    if (typeof require !== 'undefined') {
      return require(path);
    } else if (path.match(/\.json$/)) {
      return readFileSync(path, 'utf8');
    } else {
      throw Error('only .json config files are supported in ESM');
    }
  })
});

var yargsParser = function Parser(args, opts) {
  var result = parser.parse(args.slice(), opts);
  return result.argv;
};

yargsParser.detailed = function (args, opts) {
  return parser.parse(args.slice(), opts);
};

yargsParser.camelCase = camelCase;
yargsParser.decamelize = decamelize;
export default yargsParser;